import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';

function ErrorAlert({ error, onClose }) {
  const [visible, setVisible] = useState(!!error);

  useEffect(() => {
    setVisible(!!error);
  }, [error]);

  if (!error || !visible) return null;

  return (
    <div style={{
      padding: '12px 16px',
      backgroundColor: '#fef2f2',
      border: '1px solid #fecaca',
      borderRadius: '8px',
      color: '#dc2626',
      marginBottom: '24px',
      position: 'relative'
    }}>
      {error}
      <button
        onClick={onClose}
        style={{
          position: 'absolute',
          top: '12px',
          right: '12px',
          background: 'transparent',
          border: 'none',
          cursor: 'pointer',
          color: '#dc2626'
        }}
        aria-label="Close"
      >
        <X size={18} />
      </button>
    </div>
  );
}

export default ErrorAlert;
